import { Location as NgLocation } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { TranslocoDirective } from '@jsverse/transloco';
import { Subject } from 'rxjs';

import { ROUTES } from '../../../../definitions/constants/routes.constants';
import { UserConfigsStoreFacade } from '../../../../stores/global-store/user-configs/user-configs-store.facade';
import { HelperService } from '../../../../utils/helper/helper.service';

@Component({
  selector: 'app-switch-country-sidebar-content',
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TranslocoDirective
  ],
  templateUrl: './switch-country-sidebar-content.component.html',
  styleUrl: './switch-country-sidebar-content.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchCountrySidebarContentComponent implements OnInit {
  public primaryActionClicked = input.required<Subject<void>>();

  public userConfigsFacade = inject(UserConfigsStoreFacade);
  public helper = inject(HelperService);
  private readonly ngLocation = inject(NgLocation);
  private readonly destroyRef = inject(DestroyRef);

  private readonly window = window;

  public countryControl = new FormControl(
    this.userConfigsFacade.currentCountrySignal(),
    { validators: [ Validators.required ]}
  );

  public ngOnInit(): void {
    this.primaryActionClicked()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.onSwitchCountryClicked());
  }

  public onSwitchCountryClicked(): void {
    if (this.countryControl.value) {
      this.ngLocation.go(
        ROUTES.REPLENISHMENT,
        `view=INTERNAL&countryCode=${this.countryControl.value.code}`
      );
      this.window.location.reload();
    }
  }
}
